import styled from 'styled-components';

export const AddInputMLStyled = styled.div`
  .ant-form-item {
    /* margin-bottom: 10px; */
  }
  .ant-input {
    border-top-right-radius: 0px;
    border-bottom-right-radius: 0px;
    min-width: ${(props) => props.inputMinWidth};
    width: 100%;
    background: ${(props) => props.theme[props.brand].input.inputBg};
    font-size: 14px;
    color: ${(props) => props.theme[props.brand].input.color};
    height: ${(props) => props.headerHeight};
  }
  .ant-form-item-no-colon {
    margin-top: 8px;
    background: #edf0f0;
    font-size: 14px;
    border-radius: 0px;
    padding: 0 11px;
  }
  .ant-form-item-label {
    text-align: left;
    width: 169px;
    font-size: 16px;
    border-top-left-radius: 0px;
    border-bottom-left-radius: 0px;
    border: 1px solid #d9d9d9;
    border-right: 0;
    background: #edf0f0;
    height: 47px;
    color: ${(props) => props.theme[props.brand].input.color};

    label {
      text-align: left;
      width: ${(props) => props.labelWidth};
      font-size: 16px;
      border-top-left-radius: 0px;
      border-bottom-left-radius: 0px;
      background: ${(props) => props.theme[props.brand].input.inputLabelBg};
    }
  }

  .ant-input:focus {
    box-shadow: none;
  }
  .ant-input[disabled] {
    background: ${(props) => props.theme[props.brand].input.inputBg};
    color: ${(props) => props.theme[props.brand].input.color};
    cursor: default;
  }
  .ant-input:hover,
  .ant-input:focus {
    border-color: ${(props) => props.theme[props.brand].input.borderColorNew};
  }
  .detail_edit {
    .ant-input {
      background-color: #f8d8d472;
    }
  }
  .ant-form-item-control .ant-form-item-explain {
    color: ${(props) => props.theme[props.brand].input.borderColorNew};
  }
  .ant-form-item-has-error .ant-input,
  .ant-form-item-has-error .ant-input-affix-wrapper,
  .ant-form-item-has-error .ant-input:hover,
  .ant-form-item-has-error .ant-input-affix-wrapper:hover {
    border-color: ${(props) => props.theme[props.brand].input.borderColorNew};
  }
  .ant-form-item-label > label.ant-form-item-required::before {
    color: ${(props) => props.theme[props.brand].input.borderColorNew};
  }
`;
